import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, PaperPlaneRight, CheckCircle } from "@phosphor-icons/react";
import api, { apiError } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ company_name: "", contact_name: "", email: "", phone: "", message: "", interest: "custom" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/leads", form);
      setSent(true);
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen px-4 py-10">
      <div className="max-w-xl mx-auto fade-in">
        <Link to="/" data-testid="contact-back-link" className="flex items-center gap-1 text-sm text-[#16233D]/60 mb-6"><ArrowLeft size={16} /> Retour au site</Link>
        <p className="font-display font-bold text-3xl lowercase tracking-tight mb-1">kavizio</p>
        <h1 className="font-display font-bold text-2xl mb-1">Parlons de votre structure</h1>
        <p className="text-sm text-[#16233D]/65 mb-6">
          Offre Sur mesure, plusieurs établissements, besoin d'un accompagnement : laissez-nous vos coordonnées, nous vous rappelons.
        </p>

        {sent ? (
          <div className="kcard p-6 text-center space-y-3" data-testid="contact-success">
            <CheckCircle size={38} weight="fill" color="#2E7D5B" className="mx-auto" />
            <h2 className="font-display font-bold text-xl">Demande envoyée</h2>
            <p className="text-sm text-[#16233D]/70">Notre équipe vous contacte sous 48 heures ouvrées au numéro indiqué.</p>
            <Link to="/" className="btn-ghost inline-block px-5 py-2.5 text-sm">Revenir au site</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="kcard p-6 space-y-4" data-testid="contact-form">
            {error && <p data-testid="contact-error" className="text-sm text-[#B4432F] bg-[#F6E3DF] rounded-xl px-3 py-2">{error}</p>}
            <input data-testid="contact-company-input" className="kinput" placeholder="Nom de l'entreprise" value={form.company_name} onChange={set("company_name")} required />
            <input data-testid="contact-name-input" className="kinput" placeholder="Votre nom" value={form.contact_name} onChange={set("contact_name")} required />
            <div className="grid sm:grid-cols-2 gap-3">
              <input data-testid="contact-email-input" className="kinput" type="email" placeholder="Email" value={form.email} onChange={set("email")} required />
              <input data-testid="contact-phone-input" className="kinput" placeholder="Téléphone" value={form.phone} onChange={set("phone")} required />
            </div>
            <div>
              <p className="text-sm font-semibold mb-2">Offre qui vous intéresse</p>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {[["starter", "Starter"], ["pro", "Pro"], ["business", "Business"], ["custom", "Sur mesure"]].map(([v, l]) => (
                  <button type="button" key={v} data-testid={`contact-interest-${v}`} onClick={() => setForm({ ...form, interest: v })}
                    className={`py-2.5 rounded-xl border text-sm font-semibold transition-colors ${form.interest === v ? "border-[#C9793A] bg-[#C9793A]/5 text-[#C9793A]" : "border-[#E0DACE] bg-white"}`}>{l}</button>
                ))}
              </div>
            </div>
            <textarea data-testid="contact-message-input" className="kinput min-h-[110px]" placeholder="Votre activité, votre nombre d'établissements, vos besoins..." value={form.message} onChange={set("message")} />
            <button data-testid="contact-submit-btn" className="btn-amber w-full py-3 flex items-center justify-center gap-2" disabled={busy}>
              <PaperPlaneRight size={17} weight="fill" /> {busy ? "Envoi..." : "Envoyer ma demande"}
            </button>
            <p className="text-xs text-[#16233D]/55 text-center">support@kavizio.com · +224 620 00 00 00</p>
          </form>
        )}
      </div>
    </div>
  );
}
